// eslint-disable-next-line unused-imports/no-unused-vars
export const actionGQLFields = (fields) => {
    return `
    status
  `;
};
